require('@babel/register')
require('.')
